<template>
  <Select2Multiple
    class="multi-select w-100-select"
    :settings="{ multiple: multiple, placeholder: placeholder }"
    :value="value"
    :options="employeeOptions"
    @change="handleChange"
  />
</template>

<script>
import Select2Multiple from "v-select2-multiple-component";
import axios from "axios";

export default {
  name: "EmployeeSelect",
  components: { Select2Multiple },
  props: {
    value: {
      default: null,
    },
    employmentType: {
      type: Number,
      default: null,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: "Select Employee",
    },
  },
  data() {
    return {
      employeeOptions: [],
    };
  },
  watch: {
    employmentType: {
      handler() {
        this.fetchEmployees();
      },
      immediate: true,
    },
  },
  methods: {
    handleChange(val) {
      const normalized = this.multiple
        ? (Array.isArray(val) ? val : (val == null ? [] : [val]))
        : (Array.isArray(val) ? (val[0] ?? null) : val);

      this.$emit("input", normalized);
      this.$emit("change", normalized);
    },

    fetchEmployees() {
      const params = {
        exclude_admin_hr: true,
      };
      if (this.employmentType) {
        params.employeeable_type = this.employmentType;
      }
      axios.get("/employee/list", { params })
        .then((res) => {
          const employees = res.data.data || [];
          this.employeeOptions = employees.map((emp) => ({
            id: emp.id,
            text: `${emp.employee_code} - ${emp.name} (${emp.employeeable_type_text})`,
          }));
        })
        .catch((error) => {
          if (error.response && error.response.status === 401) {
            this.$store.commit("logout");
            window.location.replace("login");
          }
        });
    },
  },
};
</script>
